// Generated by CoffeeScript 2.7.0
var PushPackageTab;

export default PushPackageTab = Vue.extend({
  props: {
    initialActiveTab: {
      type: String
    }
  },
  data: function() {
    return {
      activeTab: this.initialActiveTab
    };
  },
  template: `<div class="push-package-tab sidebar-tabs tabs">
  <div class="tab-navs reverse nav">
    <div :class="tabClass('user')" @click="checkActiveTab('user')">自定义推送</div>
    <div :class="tabClass('namespace')" @click="checkActiveTab('namespace')">标准推送</div>
  </div>
</div>`,
  methods: {
    checkActiveTab: function(activeTab) {
      this.activeTab = activeTab;
      return this.$emit('tabChanged', activeTab);
    },
    tabClass: function(tab) {
      return {
        'nav-item': true,
        active: tab === this.activeTab
      };
    }
  }
});
